module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "px3 py2",
    class: {
      white: _vm.isWhite
    }
  }, [_c('div', {
    staticClass: "flex flex-wrap justify-between items-start"
  }, [_c('ul', {
    staticClass: "list-reset m0 sm-hide xs-hide flex flex-wrap items-center"
  }, [(_vm.hasLogo) ? _c('li', {
    staticClass: "h3 inline-block mr3"
  }, [_c('router-link', {
    staticClass: "logo font-ferry black",
    attrs: {
      "to": {
        name: 'HomeLang',
        params: {
          lang: _vm.lang
        }
      }
    }
  }, [_c('logotype', {
    attrs: {
      "lang": _vm.lang
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "lg-hide md-hide bold"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showSideNav($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.menuText))])]), _vm._v(" "), _c('router-link', {
    staticClass: "logo lg-hide md-hide font-ferry black",
    attrs: {
      "to": {
        name: 'HomeLang',
        params: {
          lang: _vm.lang
        }
      }
    }
  }, [_c('logotype', {
    attrs: {
      "lang": _vm.lang
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "list-reset m0 flex flex-wrap items-center bold pt1"
  }, [_c('li', {
    staticClass: "inline-block mr3 sm-hide xs-hide"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ArticlesHome',
        params: {
          lang: _vm.lang
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.content.materialsText))])], 1), _vm._v(" "), _vm._l((_vm.pages), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "inline-block mr3 sm-hide xs-hide"
    }, [(item.public) ? _c('router-link', {
      class: {
        'red': item.slug === 'petition'
      },
      attrs: {
        "to": {
          name: 'Page',
          params: {
            lang: item.language.code,
            slug: item.slug,
            oid: item.id
          }
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.content.langs), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "inline-block"
    }, [_c('router-link', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.lang !== item.slug),
        expression: "lang !== item.slug"
      }],
      attrs: {
        "to": {
          path: _vm.getCurrentPathWithLang(item.slug)
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  })], 2), _vm._v(" "), (_vm.sideNavVisible) ? _c('section', {
    staticClass: "flex flex-column justify-between",
    attrs: {
      "id": "sidenav"
    },
    on: {
      "click": function($event) {
        return _vm.stopPropagation($event)
      }
    }
  }, [_c('ul', {
    staticClass: "list-reset m0 p3"
  }, [_c('li', {
    staticClass: "mb1",
    on: {
      "click": _vm.hideSideNav
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ArticlesHome',
        params: {
          lang: _vm.lang
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.content.materialsText))])], 1), _vm._v(" "), _vm._l((_vm.pages), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "mb1",
      on: {
        "click": _vm.hideSideNav
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Page',
          params: {
            lang: item.language.code,
            slug: item.slug,
            oid: item.id
          }
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  })], 2), _vm._v(" "), _c('router-link', {
    staticClass: "font-ferry m0 px3 py3 h2 blue",
    attrs: {
      "to": {
        name: 'HomeLang',
        params: {
          lang: _vm.lang
        }
      }
    }
  }, [_c('logotype', {
    staticClass: "small",
    attrs: {
      "lang": _vm.lang
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.movieVisible) ? _c('div', {
    staticClass: "p4",
    attrs: {
      "id": "movie-modal"
    }
  }, [_vm._m(0)]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative",
      "height": "0",
      "padding-bottom": "56.25%"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "left": "0"
    },
    attrs: {
      "src": "https://www.youtube.com/embed/75KGIq7SToU?rel=0?ecver=2",
      "width": "640",
      "height": "360",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acccb76e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopNav.vue
// module id = 131
// module chunks = 0